import * as React from 'react';

import { NewbuildingSpecialProject } from '../../serp/components/adfox/templates/NewbuildingSpecialProject';
import { INewbuildingSpecialProjectBannerContext } from '../../types/adfox';

export interface ISpecialProjectAdfoxBannerContainerProps {
  context: INewbuildingSpecialProjectBannerContext;
}

export function SpecialProjectAdfoxBannerContainer({ context }: ISpecialProjectAdfoxBannerContainerProps) {
  return <NewbuildingSpecialProject context={context} />;
}
